module.exports = __webpack_public_path__ + "static/media/imagem9.5f497aea.jpeg";